import type { BlockProps } from '@gitbook/slate-react';

import { BlockWrapper } from '../common';
import { BlockStepperContextProvider } from './BlockStepperContext';
import { useBlockStepperPaletteFactory } from './palette';

/**
 * Component to render a stepper block.
 */
export function BlockStepper(props: BlockProps) {
    const { children, node } = props;

    const palette = useBlockStepperPaletteFactory({
        nodeKey: node.key,
        stepperBlockKey: node.key,
    });

    return (
        <BlockStepperContextProvider stepperBlock={node}>
            <BlockWrapper {...props} palette={palette} contentProps={{ className: 'relative' }}>
                {children}
            </BlockWrapper>
        </BlockStepperContextProvider>
    );
}
